import React from 'react';
import styled from 'styled-components';
import i18next from 'i18next';
import { Colors } from 'planoplan-ui-kit/core/colors';
import { ButtonWhite, ButtonRoute } from '../../../ui/atoms';

const getFreeSpacePercent = (quotaFreePercent) => {
  const rawPercent = 100 - quotaFreePercent;

  if (rawPercent < 15 && rawPercent > 10) {
    return 15;
  } else if (rawPercent < 10 && rawPercent > 5) {
    return 10;
  } else if (rawPercent < 5 && rawPercent > 0) {
    return 5;
  } else {
    return 0;
  }
};

const getNextTariffAlias = (currentTariff) => (currentTariff === 'pro' ? 'proplus' : 'businessvr');

export const EndOfDiskSpaceModalView = ({ onClose, quotaFree, quotaFreePercent, quotaLimit, tariff }) => (
  <Container>
    <Heading>
      {100 - quotaFreePercent > 0
        ? i18next.t('cabinet.disk_space.title.running_out')
        : i18next.t('cabinet.disk_space.title.empty')}
    </Heading>
    <Subheading>{i18next.t('cabinet.balance.storage.title')}</Subheading>
    <Progress percent={quotaFreePercent} />
    <React.Fragment>
      {i18next.t('cabinet.balance.free_space')}&nbsp;
      <React.Fragment>
        {quotaFree} {i18next.t('cabinet.misc.of')} {quotaLimit}
      </React.Fragment>
    </React.Fragment>
    <Text>
      {tariff.alias &&
        (100 - quotaFreePercent > 0
          ? i18next.t(`cabinet.disk_space.text.${tariff.alias}.running_out`, {
              percent: getFreeSpacePercent(quotaFreePercent),
            })
          : i18next.t(`cabinet.disk_space.text.${tariff.alias}.empty`))}
    </Text>
    <ButtonsContainer>
      <CloseButton onClick={onClose}>
        <ButtonText>{i18next.t('modal.cancel')}</ButtonText>
      </CloseButton>
      <ButtonRoute to={`/tariff-managment/?tariff=${getNextTariffAlias(tariff.alias)}`} onClick={onClose}>
        <ButtonText>{i18next.t('cabinet.disk_space.switch')}</ButtonText>
      </ButtonRoute>
    </ButtonsContainer>
  </Container>
);

const Container = styled.div`
  background: white;
  border-radius: 4px;
  width: 420px;
  height: auto;
  padding: 38px;
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const Heading = styled.div`
  font-size: 24px;
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  letter-spacing: normal;
  margin-bottom: 53px;
`;

const Subheading = styled.div`
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.3;
  margin-bottom: 10px;
`;

const Text = styled.div`
  flex-grow: 1;
  font-size: 20px;
  font-weight: 300;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.2;
  letter-spacing: normal;
  margin: 35px 0;
`;

const ButtonText = styled.span`
  font-size: 18px;
`;

const CloseButton = styled(ButtonWhite)`
  margin-right: 20px;
`;

const Progress = styled.div`
  width: 100%;
  height: 10px;
  border-radius: 5px;
  background-color: ${Colors.solitude};
  position: relative;
  margin-bottom: 15px;
  overflow: hidden;

  &:before {
    content: '';
    position: absolute;
    border-radius: 5px;
    background-color: ${(p) => (p.percent >= 100 ? Colors.dull_red : Colors.planoplan_blue)};
    top: 0;
    left: 0;
    width: ${(p) => `${p.percent}%`};
    height: 100%;
  }
`;
